import React, {lazy} from 'react';
import { Routes, Route } from 'react-router';
import { LoginCallback } from '@okta/okta-react';
import Home from '../Home';
import { RequiredAuth } from './SecureRoute';
import Loading from './Loading';
// import Profile from '../components/Profile';


const Profile = lazy(() =>  import('./Profile'));

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/:platform/:doc_type/:documentName/:mode" element={<Home/>} />
            <Route path="login/callback" element={<LoginCallback loadingElement={<Loading/>}/>}/>
            <Route path="/profile" element={<RequiredAuth/>}>
                <Route index element={<Profile />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
